import EffectAmount from '@/roc/effects/EffectAmount';
class EffectMod extends EffectAmount {
    __index;
    constructor(calc, amount, index) {
        super(calc, amount);
        this.__index = index;
    }
    get index() {
        return this.__index;
    }
    apply(value) {
        return value;
    }
}
export default EffectMod;
